import { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import appConfig from '@nerdwallet/app-config';
import querystring from 'query-string';
import nwApiSDK from '../../lib/nw-api-sdk';

export const postNpsQueryStrings = (query, SDK = nwApiSDK) => {
  const npsScore = parseInt(query.nps_score, 10);
  const npsToken = query.update_nps_token;
  const npsPayload = {
    nps_score: npsScore,
    update_nps_token: npsToken,
  };

  SDK.ServiceSDK.post(
    `${appConfig.API.BASE_URLS.IDENTITY}/api/v1/user-comms/nps_result`,
    npsPayload
  );
};

export const getNpsQueryStrings = (search) => {
  const query = querystring.parse(search);
  const containsNpsScoreAndToken = query.nps_score && query.update_nps_token;
  if (containsNpsScoreAndToken) {
    return query;
  }
  return null;
};

class NpsCrmEmail extends Component {
  componentDidMount() {
    const processedNpsQueryStrings = getNpsQueryStrings(
      this.props.location.search
    );
    if (processedNpsQueryStrings) {
      postNpsQueryStrings(processedNpsQueryStrings);
    }
  }

  render() {
    return null;
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
NpsCrmEmail.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
};

export default withRouter(NpsCrmEmail);
